import { useContext, useState } from 'react'

import { TextField } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { EditContext } from 'Components/Hooks/ContextEdit'
import { FormContext } from 'Components/Hooks/ContextForm'

import useStyles from '../../../styles'

const CustomTableCell = ({ row, name, onChange, isNotEnabled, isSelected }) => {
  const classes = useStyles()
  const [edit] = useContext(EditContext)
  return (
    <TableCell className={classes.tableCell}>
      {edit ? (
        <TextField
          value={row[name] === 0 ? null : row[name]}
          name={name}
          disabled={isNotEnabled ? isNotEnabled : false}
          onChange={(e) => onChange(e, row)}
          className={classes.input}
          select={isSelected ? isSelected : false}
          style={{ height: '20px' }}
          type={name === 'oblea' ?? 'string'}
        />
      ) : row[name] === 0 ? null : (
        row[name]
      )}
    </TableCell>
  )
}

const TableWithout = () => {
  const { formApi, formEdit, setFormEdit, setFormApi } = useContext(FormContext)
  const [edit] = useContext(EditContext)

  const [rows, setRows] = useState(formEdit.wafers)

  const filteredRows = rows.filter((row) => row.oblea_tipo === 2)

  const selectedCount = filteredRows.filter(
    (row) => row.check === true || row.oblea === '0' || row.oblea
  ).length

  const isSelectAllChecked =
    filteredRows.filter((row) => row.conf_obleas !== 97).length > 0 &&
    filteredRows.filter((row) => row.conf_obleas !== 97).every((row) => row.check)

  const onChange = (e, row) => {
    const updatedRows = rows.map((r) => {
      if (r.conf_obleas === row.conf_obleas) {
        return {
          ...r,
          check: e.target.checked,
          oblea: e.target.checked ? '0' : '',
        }
      }
      return r
    })

    setRows(updatedRows)
    setFormEdit({ ...formEdit, wafers: updatedRows })
    setFormApi({ ...formApi, wafers: updatedRows })
  }

  const onSelectAllChange = (e) => {
    const checked = e.target.checked
    const updatedRows = rows.map((row) => {
      if (row.oblea_tipo === 2 && row.conf_obleas !== 97) {
        return {
          ...row,
          check: checked,
          oblea: checked ? '0' : '',
        }
      }
      return row
    })
    setRows(updatedRows)
    setFormEdit({ ...formEdit, wafers: updatedRows })
    setFormApi({ ...formApi, wafers: updatedRows })
  }

  const classes = useStyles()
  return (
    <div className={classes.div}>
      <TableContainer component={Paper} style={{ maxHeight: '500px' }}>
        <Table stickyHeader size="medium">
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox
                  color="primary"
                  checked={isSelectAllChecked}
                  onChange={onSelectAllChange}
                  disabled={edit ? false : true}
                  style={{ padding: '0px' }}
                />
              </TableCell>
              <TableCell>Pieza</TableCell>
              <TableCell>Oblea</TableCell>
              <TableCell colSpan={3}>
                <span style={{ paddingRight: '10px' }}>Seleccionadas: {selectedCount}</span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.map((row) => (
              <TableRow key={row.conf_obleas}>
                <TableCell style={{ width: '50px' }}>
                  <Checkbox
                    name="check"
                    checked={
                      (row.oblea === '0' || row.oblea || row.check) && row.check !== false
                        ? true
                        : false
                    }
                    // disabled={edit ? false : true}
                    disabled={!edit || row.conf_obleas === 97}
                    onChange={(e) => onChange(e, row)}
                    color="primary"
                    style={{ padding: '0px' }}
                  />
                </TableCell>
                <TableCell
                  style={{
                    color:
                      (row.oblea === '0' || row.oblea || row.check) && row.check !== false
                        ? 'black'
                        : 'grey',
                    fontWeight:
                      (row.oblea === '0' || row.oblea || row.check) && row.check !== false
                        ? 'bold'
                        : 'regular',
                    maxWidth: '500px',
                  }}
                >
                  {row.pieza}
                </TableCell>

                <CustomTableCell {...{ row, name: 'oblea', onChange }} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default TableWithout
